import DataTable from 'datatables.net-react';
import { useEffect, useState } from 'react';
import { Col, Modal, Row } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Form from 'react-bootstrap/Form';
import Select from "react-select";
import Swal from 'sweetalert2';
import { JvBrokerListServices } from '../../services/JvBrokerListServices';
import * as BullCache from "../../util/BullCache";
import { customStyles, the } from '../components/customStyles.js';
import From from '../components/From';
import To from '../components/To';

function Jvbrokerlist() {

  const [loading, setLoading] = useState(false);
  const [broker, setBroker] = useState([]);
  const [selectedBroker, setSelectedBroker] = useState(null);
  const [jvList, setJvList] = useState([]);
  const [jvId, setJvId] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [selectedLastdate, setSelectedLastdate] = useState(
    new Date().toISOString().split("T")[0]
  );

  const handleClose = () => setShowModal(false);
  const [fromUser, setFromUser] = useState('');
  const [toUser, setToUser] = useState('');
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [amount, setAmount] = useState('');
  const [remark, setRemark] = useState('');
  const [paymentType, setPaymentType] = useState("");
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [calledFirstTime, setCalledFirstTime] = useState(false);



  var user = BullCache.getFromCache("user");
  useEffect(() => {
    JvBrokerListServices.getBroker({ 'adminId': user.adminId }).then(res => {
      if (res.code === 1) {
        if (res.data.brokerList.length > 0) {
          const brokerOptions = res.data.brokerList.map(b => ({
            value: b.adminId,
            label: `${b.firstName} (${b.userName})`
          }));
          setBroker(brokerOptions);
        }
      }
    });
  }, []);

  const handleBrokerChange = (selectedOption) => {
    setSelectedBroker(selectedOption ? selectedOption.value : null);
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleLastdateChange = (e) => {
    setSelectedLastdate(e.target.value);
  };
  const handleFromDateChange = (newDate) => {
    setFromDate(newDate);
    setSelectedDate(newDate);
  };
  const handleToDateChange = (newDate) => {
    setToDate(newDate);
    setSelectedLastdate(newDate);
  };

  useEffect(() => {
    if (fromDate && toDate && !calledFirstTime) {
      const dataToSubmit = {
        adminId: user.adminId,
        date: fromDate,
        endDate: toDate,
      };

      fetchData(dataToSubmit);
      setCalledFirstTime(true);
    }
  }, [fromDate, toDate]);

  const fetchData = (dataToSubmit) => {
    setLoading(true);
    JvBrokerListServices.getJvBrokerList(dataToSubmit)
      .then((resp) => {
        setLoading(false);
        if (resp.code === 1 && resp.data.jvList.length > 0) {
          setJvList(resp.data.jvList);
        } else {
          setJvList([]);
        }
      })
      .catch((error) => {
        console.error('Error fetching trade data:', error);
      });
  };

  const jvBrokerSearch = () => {
    const brokerId = selectedBroker || user.adminId;
    const payment = {
      adminId: brokerId,
      date: fromDate || selectedDate,
      endDate: toDate || selectedLastdate,

    };
    setLoading(true);
    JvBrokerListServices.getJvBrokerList(payment).then((resp) => {
      setLoading(false);
      if (resp.code === 1) {
        if (resp.data.jvList.length > 0) {
          setJvList(resp.data.jvList);
        } else {
          setJvList([]);
        }
      } else {
        Swal.fire({
          icon: "error",
          text: "Something Went to Wrong!",
        });
      }
    });
  }
  const handleDelete = (rowData) => {
    const requestData = {
      adminId: user.adminId,
      jvId: rowData.jvId,
    };

    JvBrokerListServices.deleteJvBroker(requestData).then((res) => {
      if (res.code === 1) {
        Swal.fire({
          icon: "success",
          text: "Deleted Successfully!",
        });
        jvBrokerSearch();
        handleClose();
      } else {
        Swal.fire({
          icon: "error",
          text: res.message || "Failed to Delete!",
        });
      }
    });
  };

  useEffect(() => {
    const handlePencilClick = (event) => {
      const jvId = event.target.getAttribute("data-id");
      const rowData = jvList.find((jv) => jv.jvId === jvId);
      if (rowData) {
        setFromUser(`${rowData.adminFrom.firstName} (${rowData.adminFrom.userName})`);
        setToUser(`${rowData.adminTo.firstName} (${rowData.adminTo.userName})`);
        setFrom(rowData.adminFrom.adminId);
        setJvId(rowData.jvId);
        setTo(rowData.adminTo.adminId);
        setAmount(rowData.amount);
        setRemark(rowData.remark);
        setSelectedDate(rowData.createdDate);
        setPaymentType(rowData.paymentType);

      }
      setShowModal(true);
    };

    const handleTrashClick = (event) => {
      const jvId = event.target.getAttribute("data-id");
      const rowData = jvList.find((jv) => jv.jvId === jvId);
      Swal.fire({
        title: 'Are you sure?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
        cancelButtonText: 'No',
        cancelButtonColor: "#d33",
      }).then((result) => {
        if (result.isConfirmed) {
          handleDelete(rowData);
        }
      });
    };

    document.addEventListener("click", (event) => {
      if (event.target.classList.contains("icon-pencil")) {
        handlePencilClick(event);
      } else if (event.target.classList.contains("icon-trash")) {
        handleTrashClick(event);
      }
    });

    return () => {
      document.removeEventListener("click", handlePencilClick);
      document.removeEventListener("click", handleTrashClick);
    };
  }, [jvList]);

  const handleUpdate = () => {
    const updateJvBroker = {
      jvId,
      from: from,
      to: to,
      paymentType,
      jvType: "BROKER",
      amount,
      remark,
      createdDate: selectedDate,
    };

    JvBrokerListServices.getUpdateJvBroker(updateJvBroker).then(response => {
      if (response.code === 1) {
        Swal.fire({
          icon: "success",
          text: "Updated !",
        });
        const updatedJvList = jvList.map((jv) =>
          jv.jvId === jvId
            ? { ...jv, paymentType, amount, remark, createdDate: selectedDate }
            : jv
        );
        setJvList(updatedJvList);
        handleClose();
      } else {
        Swal.fire({
          icon: "error",
          text: "Failed !",
        });
      }
    }).catch(error => {
      Swal.fire({
        icon: "error",
        text: "Something Went to Wrong !",
      });
    });
  };

  const columns = [
    {
      title: "FROM",
      className: "  text-center fss-1 font-bold ledger bg-body ",
      render: (data, type, full, meta) => {
        const adminFrom = full.adminFrom ? full.adminFrom.firstName + " (" + full.adminFrom.userName + ")" : "No User";
        return adminFrom;
      }
    },
    {
      title: "TO",
      className: "  text-center fss-1 font-bold ledger bg-body ",
      render: (data, type, full, meta) => {
        const adminTo = full.adminTo ? full.adminTo.firstName + " (" + full.adminTo.userName + ")" : "No User";
        return adminTo;
      }
    },
    {
      title: "DATE",
      data: "createdDate",
      className: " ledger bg-body text-center font-bold fss-1",
      render: (data) => {
        return new Date(data).toLocaleDateString();
      },
    },
    {
      title: "AMOUNT",
      data: "amount",
      className: " ledger bg-body text-center fss-1 ",
    },
    {
      title: "REMARK",
      data: "remark",
      className: " ledger bg-body text-center font-bold  fss-1 ",
    },
    {
      title: "ACTION",
      className: " ledger bg-body text-center font-bold  fss-1 ",
      render: (data, type, full, meta) => {
        return `
            <i class="me-3 fa fa-pencil icon-pencil" data-id="${full.jvId}" style="cursor: pointer"></i>
            <i class="icon-trash fa fa-trash" data-id="${full.jvId}" style="cursor: pointer; color: red"></i>
          `;
      },
    },
  ];

  return (

    <div>

      <Card className='mt-2'>
        <Card.Body>
          <Row>
            <Col sm={2} xs={6} >
              <b className="fss-08">SELECT </b>
              <Select
                isSearchable
                options={broker}
                value={broker.find(b => b.value === selectedBroker)}
                onChange={handleBrokerChange}
                placeholder="Select"
                getOptionLabel={(e) => e.label}
                getOptionValue={(e) => e.value}
                styles={customStyles}
                theme={the}
              />

            </Col>

            <Col sm={2} xl={1} xs={6} className=''>
              <b className=' fss-08'>FROM</b><br />
              <From fromDate={fromDate} onDateChange={handleFromDateChange} />
            </Col>
            <Col sm={2} xs={6} className=''>
              <b className='fss-08'>TO</b><br />
              <To toDate={toDate} setToDate={handleToDateChange} />
            </Col>

            <Col xs={6} sm={2} className="mt-4">
              <Button variant="success" size="sm w-50" className="fss-08" onClick={jvBrokerSearch} >
               GET
              </Button>
            </Col>

            <Col></Col>
            <Col></Col>
            <Col></Col>
            <Col></Col>
          </Row>

        </Card.Body>
      </Card>

      <Card className="mt-2">
        <Card.Body>
          <div className="table-responsive">
            {loading ? (
              <div className="container vh-100">
                <div className="d-flex align-items-center justify-content-center h-90">
                  <div className="spinner-border text-secondary m-5" role="status" style={{ width: '4rem', height: '4rem' }}>
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <DataTable
                id="table"
                className=" table table-bordered bg-head-secondary fss-09 white-bordered-table"
                columns={columns}
                data={jvList}
              />
            )}
          </div>
        </Card.Body>
      </Card>

      <Modal show={showModal} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>EDIT JV BROKER ENTRY</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className="col-6">FROM: {fromUser}</Col>

            <Col className="col-6 text-end">TO: {toUser}</Col>
          </Row>
          <hr />
          <Row className="mt-3 border rounded p-1">
            <Col className="col-5"><label>PAYMENT TYPE :</label></Col>

            <Col>
              <Form.Check
                type="radio"
                aria-label="radio 1"
                label="CASH"
                name="group2"
                checked={paymentType === "CASH"}
                onChange={() => setPaymentType("CASH")}
              />
            </Col>
            <Col>
              <Form.Check
                type="radio"
                aria-label="radio 2"
                label="ONLINE"
                name="group2"
                checked={paymentType === "ONLINE"}
                onChange={() => setPaymentType("ONLINE")}
              />
            </Col>
          </Row>
          <Row className="mt-2">
            <Col sm={12}>DATE</Col>
            <Col className="mt-1">
              <input
                type="date"
                size="lg"
                className="form-control"
                value={selectedDate}
                onChange={(e) => setSelectedDate(e.target.value)}
              />
            </Col>
          </Row>

          <Row className="mt-3">
            <Col sm={12}>AMOUNT</Col>
            <Col className="mt-1">
              <input
                type="number"
                className="form-control  bg-light text-black"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
              />
            </Col>
          </Row>
          <Row>
            <Col sm={12} className="mt-3">
              REMARK
            </Col>
            <Col className="mt-1">
              <Form.Control
                as="textarea"
                className="custom-placeholder bg-light text-black"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
              />
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            Close
          </Button>
          <Button variant="success" onClick={handleUpdate}>
            Update
          </Button>
        </Modal.Footer>
      </Modal>

    </div>


  );

}
export default Jvbrokerlist;